import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Modal, Button } from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import SvgIcon from "../components/const/SvgIcon";
import { allApiAction } from "../Redux/common/action";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";

const defaultObj = {
  title: "",
  description: "",
  youtube_video: "",
  is_feature: false,
};

function YouTube() {
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [youtubeDetails, setYoutubeDetails] = useState({ ...defaultObj });

  const { youtubeList } = useSelector((state) => ({
    youtubeList: state?.allApi?.youtube_list || {},
  }));

  const listData = youtubeList?.data ? youtubeList?.data : [];

  useEffect(() => {
    dispatch(allApiAction.getYoutube({ page: page, search: search }));
  }, [search, page]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div dangerouslySetInnerHTML={{ __html: text }} style={{ wordBreak: "break-word" }} />
      ),
    },
    {
      title: "YouTube ID",
      dataIndex: "youtube_video",
      key: "youtube_video",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item) => (
        <>
          <Tooltip title="Edit">
            <span
              className="cursor-pointer"
              onClick={() => {
                handleModal(item);
              }}
            >
              <SvgIcon.Edit className="scale-icon edit-icon" />
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span
              className="cursor-pointer"
              onClick={() => showDeleteConfirm(item?.id)}
            >
              <SvgIcon.deletebtn className="scale-icon edit-icon" />
            </span>
          </Tooltip>
        </>
      ),
    },
  ];

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure delete?",
      icon: <ExclamationCircleFilled />,
      content: "YouTube Video",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleDelete = async (id) => {
    await dispatch(allApiAction.deleteYoutube({ id: id, page }));
    dispatch(allApiAction.getYoutube({ page }));
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setYoutubeDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleModal = (editData) => {
    if (editData) {
      setYoutubeDetails(editData);
    } else {
      setYoutubeDetails({ ...defaultObj });
    }
    setIsModalOpen(true);
  };

  const handleSubmit = async () => {
    try {
      if (youtubeDetails.id) {
        await dispatch(allApiAction.updateYoutube(youtubeDetails));
      } else {
        await dispatch(allApiAction.addYoutube(youtubeDetails));
      }
      dispatch(allApiAction.getYoutube({ page: 1 }));
      handleModal();
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      <div className="flex">
        <div>
          <HeadingBack
            title="YouTube"
            subHeading={`Total ${youtubeList?.total || 0} Videos`}
          />
        </div>

        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className="table antd_table"
          pagination={{
            current: page,
            pageSize: 10,
            onChange: (current) => setPage(current),
            hideOnSinglePage: true,
            total: youtubeList?.total || 0,
          }}
        />
      </div>

      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title={youtubeDetails.id ? "Edit YouTube Video" : "Add YouTube Video"}
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Title"
            name="title"
            value={youtubeDetails.title}
            onChange={handleTextChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Description"
            name="description"
            value={youtubeDetails.description}
            onChange={handleTextChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <input
            autoComplete="off"
            className="form-control"
            placeholder="YouTube Video ID (e.g. 9udS0mpi1L4)"
            name="youtube_video"
            value={youtubeDetails.youtube_video}
            onChange={handleTextChange}
          />
        </Col>
      </Modal>
    </div>
  );
}

export default YouTube;